import { store } from 'src/redux/Store';
import UserSecurity from 'src/models/UserSecurity';

export default class CurrentUser {
    public static Get(): UserSecurity | null {
        return store.getState().UserSession.Value;
    }
}